<div class="flex flex-column align-items-center justify-content-center gap-3 py-3 px-2">
	<p-progressSpinner ariaLabel="loading" [style]="{width: '3rem', height: '3rem'}" strokeWidth="4"></p-progressSpinner>
	<!-- TODO: re-enable firmware progress percentage (event 94 / DeviceStatus.Percentage)
	<div *ngIf="percentage !== undefined && percentage !== null" class="font-semibold">{{ percentage }}%</div>
	-->
	<p-button [label]="'BACK_TO_DEVICES' | translate" icon="pi cm-arrow-left"
		(click)="backToDevices()" [rounded]="false" [text]="true" severity="secondary"
		styleClass="font-bold">
	</p-button>
</div>
